module.exports = __webpack_public_path__ + "static/logo_1024x305-30d8e76296c9c12f3b22abbb1a7faa7f.jpg";